module.exports = __webpack_public_path__ + "media/8_3.6597e88f.wav";